export class ArticleExcelImport {
  articleId: string;
  depth: number | null;
  insideWidth: number | null;
  outsideWidth: number | null;
  productName: string | null;
  profileType: string | null;
  country: string | null;
  application: string | null;
  fileName: string | null;
  innerRadius: number | null;
  outerRadius: number | null;
  thickness: number | null;
  engineeringCode: string | null;
  material: string | null;
  isRolled: boolean = false;


  constructor(
    fileName: string | null, row: Record<string, string | number | null>
  ) {
    // this.articleId = row['ArticleId'] != null ? String(row['ArticleId']) : '';
    // this.depth = row['Depth'] as number | null;
    // this.insideWidth = row['Inside Width'] as number | null;
    // this.outsideWidth = row['Outside Width'] as number | null;
    // this.productName = row['Product Name'] as string;
    // this.profileType = row['Profile Type'] as string | null;
    // this.country = row['Country'] as string | null;
    // this.application = row['Application'] as string | null;
    // this.fileName = fileName as string | null;
    // this.innerRadius = row['Inner Radius'] as number | null;
    // this.outerRadius = row['Outer Radius'] as number | null;
    // this.thickness = row['Thickness'] as number | null;
    // this.engineeringCode = row['Engineering Code'] as string | null;
    // this.material = row['Material'] as string | null;
    // this.isRolled = row['IsRolled'] as boolean | null || false;

    const numOrNull = (val: any): number | null =>
      val === undefined || val === null || val === '' || isNaN(Number(val))
        ? null
        : Number(val);

    const strOrNull = (val: any): string | null =>
      val === undefined || val === null || val === ''
        ? null
        : String(val);

    this.articleId = row['ArticleId'] != null ? String(row['ArticleId']) : '';
    this.depth = numOrNull(row['Depth']);
    this.insideWidth = numOrNull(row['Inside Width']);
    this.outsideWidth = numOrNull(row['Outside Width']);
    this.productName = strOrNull(row['Product Name']);
    this.profileType = strOrNull(row['Profile Type']);
    this.country = strOrNull(row['Country']);
    this.application = strOrNull(row['Application']);
    this.fileName = strOrNull(fileName);
    this.innerRadius = numOrNull(row['Inner Radius']);
    this.outerRadius = numOrNull(row['Outer Radius']);
    this.thickness = numOrNull(row['Thickness']);
    this.engineeringCode = strOrNull(row['Engineering Code']);
    this.material = strOrNull(row['Material']);

    // Boolean handling
    // Boolean → ulong conversion
    const isRolledValue = row['IsRolled'];
    if (typeof isRolledValue === 'boolean') {
      this.isRolled = isRolledValue ? true : false;
    } else if (typeof isRolledValue === 'string') {
      const val = isRolledValue.trim().toLowerCase();
      this.isRolled = (val === 'true' || val === '1') ? true : false;
    } else if (typeof isRolledValue === 'number') {
      this.isRolled = isRolledValue === 1 ? true : false;
    } else {
      this.isRolled = false; // default
    }
  }
}